interface CompareStepProps {
  currentImageUrl: string;
  candidateImageUrl: string;
}

export function CompareStep({ currentImageUrl, candidateImageUrl }: CompareStepProps) {
  return (
    <div className="refine-step refine-step--compare">
      <h3 className="refine-step__title">Pick the one you prefer</h3>
      <div className="refine-step__compare-grid">
        <figure className="refine-step__compare-figure">
          <img
            src={currentImageUrl}
            alt="Current illustration"
            className="refine-step__compare-img"
          />
          <figcaption>Current</figcaption>
        </figure>
        <figure className="refine-step__compare-figure">
          <img
            src={candidateImageUrl}
            alt="Refined illustration"
            className="refine-step__compare-img"
          />
          <figcaption>Refined</figcaption>
        </figure>
      </div>
    </div>
  );
}
